export default function FigureTile({ name, portrait, className }) {
  return (
    <div className={`bg-white p-2 xl:p-3 ${className}`} style={{ direction: "ltr" }}>
      <img src={portrait} width="150px" height="150px" />
      <div className="text-extraTiny xl:text-tiny font-bold uppercase mt-2">{name}</div>
    </div>
  );
}
